import {AnyAction} from 'redux';
import {PlayerReducer as State} from '../../@types/reducers';
import {
    BOOK_EVENT_SUCCESS,
    DEFAULT_SETTINGS,
    DELETE_SETTINGS_SUCCESS,
    GET_EVENT_SUCCESS,
    GET_PLAYERS,
    GET_PLAYERS_SUCCESS,
    GET_SETTINGS_SUCCESS,
    HIDE_ALERT_SUCCESS,
    NEW_BOOKED_EVENT,
    NEW_HIDDEN_ALERT,
    PLAYER_EVENT,
    PLAYER_INITIALIZE_SUCCESS,
    SET_ACTIVE_PLAYERS,
    SET_ORDER,
    SET_SETTINGS,
    SET_SETTINGS_AVERAGE_BOOKMAKERS,
    STORE_PLAYER_INITIALIZE,
} from "../../constants/PlayerConstants";
import {AVERAGE} from "../../constants/CommonConstants";
import {AlertPlayerObject, PlayerProcessingEvent} from "../../@types/response";
import {processEvent} from "../utils/playerUtils";
import {ActiveEventIds} from "../utils/searchFixtures";

const initialState: State = {
    initializing: true,
    monitors: [],
    booked: [],
    eventPlayers: null,
    hides: {},
    template: null,
    templates: [],
    settings: DEFAULT_SETTINGS,
    activeEventIds: new Set<number>(),
    books: []
};

const playerReducer = (state = initialState, action: AnyAction): State => {
    switch (action.type) {
        case SET_SETTINGS: {
            const settings = Object.assign({}, state.settings, action.payload)
            return {
                ...state,
                settings: settings,
            }
        }
        case SET_SETTINGS_AVERAGE_BOOKMAKERS: {
            let settings = {...state.settings}
            settings.comparisons[AVERAGE].bookmakers = action.payload
            return {
                ...state,
                settings: settings,
            }
        }
        case STORE_PLAYER_INITIALIZE: {
            if (state.templates.includes(action.payload.name))
                return state
            return {
                ...state,
                templates: [...state.templates, action.payload.name]
            }
        }
        case PLAYER_INITIALIZE_SUCCESS: {
            return {
                ...state,
                settings: action.payload.settings,
                hides: action.payload.hides,
                booked: action.payload.booked,
                books: action.payload.books,
                initializing: false
            };
        }
        case GET_SETTINGS_SUCCESS: {
            return {
                ...state,
                settings: action.payload.settings,
                template: action.payload.template
            };
        }
        case DELETE_SETTINGS_SUCCESS: {
            return {
                ...state,
                templates: state.templates.filter((item: string) => item !== action.payload.template)
            };
        }
        case GET_PLAYERS: {
            return {
                ...state,
                initializing: true
            }
        }
        case SET_ACTIVE_PLAYERS: {
            const activeEventIds: ActiveEventIds = new Set<number>(action.payload)
            return {
                ...state,
                activeEventIds,
            };
        }
        case GET_PLAYERS_SUCCESS: {
            const monitors: AlertPlayerObject[] = action.payload
                .map((e: PlayerProcessingEvent) => processEvent(e, state.settings, state.hides, state.booked))
                .flat()
            return {
                ...state,
                monitors,
                initializing: false
            };
        }
        case PLAYER_EVENT: {
            const monitors = state.monitors
                .filter(m => m.eventId !== action.payload.eventId)
                .concat(processEvent(action.payload, state.settings, state.hides, state.booked))
            const eventId: number = action.payload.eventId
            const hasActive: boolean = !!action.payload.bookmakers
                && Object.keys(action.payload.bookmakers).length > 0
            const activeEventIds = new Set(state.activeEventIds)
            if (hasActive) {
                activeEventIds.add(eventId)
            } else {
                activeEventIds.delete(eventId)
            }
            return {
                ...state,
                monitors,
                activeEventIds,
            };
        }
        case SET_ORDER: {
            return {
                ...state,
                settings: Object.assign({}, state.settings, {order: action.payload})
            };
        }
        case HIDE_ALERT_SUCCESS:
        case NEW_HIDDEN_ALERT: {
            const hides = Object.assign({}, state.hides, action.payload)
            return {
                ...state,
                hides: hides,
                monitors: state.monitors.filter(alert => !Object.keys(action.payload).includes(`${alert.eventId}-${alert.playerId}-${alert.marketId}-${alert.sbv}-${alert.signId}`))
            };
        }
        case BOOK_EVENT_SUCCESS:
        case NEW_BOOKED_EVENT: {
            const booked = [...state.booked, action.payload]
            return {
                ...state,
                booked: booked,
                monitors: state.monitors.filter(alert => !booked.includes(`${alert.eventId}-${alert.playerId}-${alert.marketId}-${alert.sbv}-${alert.signId}`))
            };
        }
        case GET_EVENT_SUCCESS:
            return {
                ...state,
                eventPlayers: action.payload
            };
        default:
            return state;
    }
};

export default playerReducer;
